import React from 'react';
import { usePlayerContext } from '../Context';

const ControlIcon = ({
  iconName,
  spin = false,
}: {
  iconName: string;
  spin?: boolean;
}) => {
  const { sdk } = usePlayerContext();
  const prefix = sdk.getClassNamePrefix();

  const iconMap: { [key: string]: string } = {
    play: `${prefix}-icon-solid ${prefix}-icon-play`,
    circlePause: `${prefix}-icon-solid ${prefix}-icon-circle-pause`,
    airplay: `${prefix}-icon-solid ${prefix}-icon-airplay`,
    headphones: `${prefix}-icon-solid ${prefix}-icon-headphones`,
    compress: `${prefix}-icon-solid ${prefix}-icon-compress`,
    expand: `${prefix}-icon-solid ${prefix}-icon-expand`,
    gauge: `${prefix}-icon-solid ${prefix}-icon-gauge`,
    sliders: `${prefix}-icon-solid ${prefix}-icon-sliders`,
    arrowRotateRight: `${prefix}-icon-solid ${prefix}-icon-arrow-rotate-right`,
    arrowRotateLeft: `${prefix}-icon-solid ${prefix}-icon-arrow-rotate-left`,
    clone: `${prefix}-icon-solid ${prefix}-icon-clone`,
    gear: `${prefix}-icon-solid ${prefix}-icon-gear`,
    closedCaptioning: `${prefix}-icon-regular ${prefix}-icon-closed-captioning`,
    volumeHigh: `${prefix}-icon-solid ${prefix}-icon-volume-high`,
    volumeXmark: `${prefix}-icon-solid ${prefix}-icon-volume-xmark`,
    chevronLeft: `${prefix}-icon-solid ${prefix}-icon-angle-left`,
    chevronRight: `${prefix}-icon-solid ${prefix}-icon-angle-right`,
    spinner: `${prefix}-icon-solid ${prefix}-icon-spinner ${prefix}-icon-spin`,
  };

  const iconClass = iconMap[iconName];

  if (!iconClass) {
    console.warn(`Icon "${iconName}" not found in FontAwesome library`);
    return null;
  }

  // Générer la classe CSS pour FontAwesome, avec l'option spin
  const classNames = `${iconClass} ${spin ? prefix + '-spin' : ''}`;

  return (
    <i
      className={`${prefix}-player-control-icon ${classNames}`}
      aria-hidden="true"
    ></i>
  );
};

export default ControlIcon;
